module.exports = __webpack_public_path__ + "static/media/VeryHappy.055805a1.png";